// extracted by mini-css-extract-plugin
module.exports = {"spacedContent":"spaced-content_spacedContent__Ih8WB"};